import { jsx as l } from "react/jsx-runtime";
const a = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m15.968 56.707-.708-5.066c4.668 3.992 10.541 6.168 16.748 6.166 6.893-.002 13.373-2.688 18.247-7.564a25.824 25.824 0 0 0 6.682-11.579 25.98 25.98 0 0 0 .179-12.618l-4.009.947a21.808 21.808 0 0 1-.189 10.755 21.68 21.68 0 0 1-5.577 9.583 21.552 21.552 0 0 1-15.334 6.357 21.532 21.532 0 0 1-14.472-5.529l5.46-.763-.57-4.079-12.248 1.713 1.713 12.248 4.079-.57-.001-.001ZM10.771 27.553a21.604 21.604 0 0 1 5.891-10.885 21.552 21.552 0 0 1 15.334-6.357 21.546 21.546 0 0 1 15.338 6.348 22.02 22.02 0 0 1 1.552 1.726l-5.717-1.522-1.06 3.981 11.952 3.183 3.183-11.952-3.981-1.06-1.249 4.688a26.2 26.2 0 0 0-1.769-1.957C45.369 8.873 38.888 6.19 31.994 6.192c-6.893.002-13.373 2.688-18.247 7.564a25.706 25.706 0 0 0-7.01 12.956 25.85 25.85 0 0 0 1.074 14.299l3.861-1.435a21.732 21.732 0 0 1-.902-12.023h.001Z"
      }
    )
  }
);
export {
  a as LoadingAndFlexibility
};
